<template>
  <div class="cuaderno-ruta w-100 p-2" v-if="cuaderno.length">
    <!--MODALS-->
    <transition name="modalEstados" v-if="showModal">
      <div class="modal-mask">
        <div class="modal-wrapper" style="width: 18rem;">
          <div class="card-body modal-container">
            <h5 class="card-title">{{ texto.mdlEstados.titulo }}</h5>
            <div class="flex-grow-1 d-flex flex-column justify-content-start align-items-left text-white">
              <div class="bg-success my-1 p-2 rounded leyenda">
                <span>{{ texto.mdlEstados.abierto }}</span>
              </div>
              <div class="bg-warning my-1 p-2 rounded leyenda">
                <span>{{ texto.mdlEstados.online }}</span>
              </div>
              <div class="bg-info my-1 p-2 rounded leyenda">
                <span>{{ texto.mdlEstados.guardado }}</span>
              </div>
              <div class="bg-danger my-1 p-2 rounded leyenda">
                <span>{{ texto.mdlEstados.cerrado }}</span>
              </div>
            </div>
            <button id="close-modal" class="btn btn-outline-success btn-block mt-3" @click="showModal = false">
              {{ texto.btnCerrar }}
            </button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="modalNoGuardado" v-if="showGuardado">
      <div class="modal-mask">
        <div class="card modal-wrapper" style="width: 18rem;">
          <div class="card-body modal-container">
            <h5 class="card-title text-center">{{ texto.mdlGuardado.atencion }}</h5>
            <p class="mb-1">{{ texto.mdlGuardado.mensaje }}</p>
            <button class="btn btn-outline-success btn-block mt-3" @click="showGuardado = false">
              {{ texto.btnCerrar }}
            </button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="modalSinFechas" v-if="mostrarMensaje">
      <div class="modal-mask">
        <div class="modal-wrapper" style="width: 18rem;">
          <div class="card-body modal-container">
            <h5 class="card-title text-center">{{ texto.mdlFechas.atencion }}</h5>
            <p class="mb-1">{{ texto.mdlFechas.mensaje }}</p>
            <button class="btn btn-outline-success btn-block mt-3" @click="mostrarMensaje = false">
              {{ texto.btnCerrar }}
            </button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="modalEncuesta" v-if="mostrarEncuesta">
      <div class="modal-mask">
        <div class="modal-wrapper" style="width: 18rem;">
          <div class="card-body modal-container encuesta">
            <img src="https://resources.entrepyr.eu/img/logo_principal@2x.png" alt="" class="ok">
            <img src="https://entrepyr2.eu/assets/img/logo_principal@2x.png" alt="" class="ok">
<!--            <h5 class="card-title text-center">{{ texto.mdlEncuesta.titulo }}</h5>-->
<!--            <p class="mb-1">{{ texto.mdlEncuesta.mensaje }}</p>-->
            <p>Próximamente se podrán realizar las reservas desde está web</p>
            <p>Vous pourrez bientôt faire des réservations à partir de ce site web.</p>
            <p>Properament es podran realitzar les reserves des està web</p>
            <p>Bookings will soon be available on this website.</p>

            <div class="card-footer">
              <button class="btn btn-success btn-block mt-3" @click="mostrarEncuesta = false">
                {{ texto.btnCerrar }}
              </button>
            </div>
          </div>

        </div>
      </div>
    </transition>

    <transition name="modalRutas" v-if="mostrarRuta">
      <div class="modal-mask">
        <div class="modal-wrapper" style="width: 18rem;">
          <div class="card-body modal-container encuesta">
            <img src="https://entrepyr2.eu/assets/img/logo_principal@2x.png" alt="" class="ok">
            <h5 class="card-title text-center">{{ texto.mdlRutas.titulo }}</h5>

            <div class="card-footer row pt-3">
              <div class="col-6">
                <button class="btn btn-block btn-warning" @click="mostrarRuta = false">
                  {{ texto.btnCerrar }}
                </button>
              </div>
              <div class="col-6">
                <button class="btn btn-block btn-success" @click="xsalto">
                  {{texto.mdlRutas.btnPago}}
                </button>
              </div>
              <div class="d-flex flex-row justify-content-center align-items-center align-content-center">

              </div>
            </div>
          </div>

        </div>
      </div>
    </transition>

    <!-- /MODALS-->


    <div class="d-flex flex-row mb-2 justify-content-start align-items-center">
      <h2 class="text-light"> {{ texto.titulo }}
        <sup>
          <button type="button" class="btn btn-floating btn-info text-white" style="width: 1.2rem; height: 1.2rem;"
                  @click="showModal = true">
            <i class="fas fa-info"></i>
          </button>
        </sup>
      </h2>
    </div>
    <div class="cuaderno d-flex flex-column justify-content-start align-items-start">

      <div v-if="esMovil" class="row mt-1 d-flex flex-column justify-content-start align-items-center align-content-center">
        <div class="col estados d-flex flex-column mb-3 align-self-start">
          <div class="d-flex flex-row my-1">
            <span class="rounded-circle estado disponible"></span>
            <span class="text-white ml-1 mr-2 texto">{{ texto.mdlEstados.abierto }}</span>
          </div>
          <div class="d-flex flex-row my-1">
            <span class="rounded-circle estado online"></span>
            <span class="text-white ml-1 mr-2 texto">{{ texto.mdlEstados.online }}</span>
          </div>
          <div class="d-flex flex-row my-1">
            <span class="rounded-circle estado guardado"></span>
            <span class="text-white ml-1 mr-2 texto">{{ texto.mdlEstados.guardado }}</span>
          </div>
          <div class="d-flex flex-row my-1">
            <span class="rounded-circle estado cerrado"></span>
            <span class="text-white ml-1 mr-2 texto">{{ texto.mdlEstados.cerrado }}</span>
          </div>

        </div>
        <div class="col d-flex flex-column mb-3">
          <Refugio class=" mb-2" v-for="item in cuaderno" :key="item.id" :seleccionado="item"
                   @seleccionDia="diaPulsado" @remover="removerRefugio(item.id)"
          ></Refugio>
        </div>
      </div>

      <div v-else class="w-100 d-flex flex-column">
      <div
          class="cuaderno-control-fechas mb-2 col-1 offset-md-2 col-push-2 h-100 d-flex flex-row align-self-end align-items-center">
        <button @click="posteriores">
          <i class="fa fa-caret-left"></i></button>

        <button @click="anteriores">
          <i class="fa fa-caret-right"></i></button>
      </div>
        <div  class="cuaderno-datos d-flex flex-row mb-1 col-12" v-for="item in cuaderno" :key="item.id"
             draggable="true" @dragstart="dragRefugio" @dragover.prevent @drop="dropRefugio" :data-id="item.id">
          <div
                class="cuaderno-nombre-refugio col-2 text-light d-flex flex-column justify-content-center align-items-start"
                :data-id="item.id">
              {{ item.name }}
            </div>
          <div class="cuaderno-datos-dias p-1 col-9 text-white d-flex p-0" :data-id="item.id">
              <button v-for="dia in diasDisponibles" :key="`${item.id}_${dia}`" @click="diaPulsado(item, dia)"
                      class="btn text-white d-flex flex-column justify-content-center
                align-items-center rounded-lg mx-1 p-1"
                      :data-id="item.id"
                      :class="estadoDia(dia, item)"
              >
                <span class="fecha">{{ dia| fechaEs }}</span>
                <span class="seleccion">{{ item.fechas.includes(dia) ? '✔' : '➖' }}</span>
              </button>
            </div>
          <div
                class="cuaderno-borrar-refufio col-1 h-100 d-flex flex-row align-self-end justify-content-start align-items-center">
              <button class="boton-papelera"
                      @click="removerRefugio(item.id)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>
        </div>
      </div>

    </div>
    <div v-if="esMovil && rutas.length" class="d-flex flex-column justify-content-start align-items-start">
      <div class="col d-flex flex-column mb-3">
        <Ruta v-for="ruta in rutas"
              :key="ruta.id" :idioma="texto.rutas" :seleccionado="ruta"
              :gpx="`https://api.entrepyr.eu/geometries/route/${lang}/${ruta.id}.gpx`"
              :ficha="`/route/${ruta.id}.html`"
              :pdf="`#`"
              @quitarRuta="borrarRuta"
              class="mb-2">

        </Ruta>
      </div>
    </div>
    <div class="col-12 text-white d-flex flex-column p-0 mt-4 pt-2" v-if="!esMovil && rutas.length">
      <h5 class="text-light ">{{ texto.rutas.titulo }}</h5>
      <table >
        <thead>
        <tr>
          <th class=" border-bottom">{{ texto.rutas.nombre }}</th>
          <th colspan="4" class="text-center border-bottom">{{ texto.rutas.ida }}</th>
          <th colspan="4" class="text-center border-bottom">{{ texto.rutas.vuelta }}</th>
          <th class="border-bottom text-center">GPX</th>
          <th class="border-bottom text-center">PDF</th>
          <th class="border-bottom text-center">{{ texto.rutas.ficha }}</th>
          <th>&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>&nbsp;</td>
          <td class="text-center"><i class="fa fa-arrow-right"></i></td>
          <td class="text-center"><i class="fa fa-arrow-right ascenso"></i></td>
          <td class="text-center"><i class="fa fa-arrow-right descenso"></i></td>
          <td class="text-center border-right"><i class="fa fa-clock"></i></td>
          <td class="text-center"><i class="fa fa-arrow-right"></i></td>
          <td class="text-center"><i class="fa fa-arrow-right ascenso"></i></td>
          <td class="text-center"><i class="fa fa-arrow-right descenso"></i></td>
          <td class="text-center border-right"><i class="fa fa-clock"></i></td>
          <td colspan="4">&nbsp;</td>
        </tr>
        <tr v-for="ruta in rutas" :key="ruta.id" class="datos-ruta">
          <td class="text-left" width="33%" :title="ruta.name">{{ ruta.name | truncate(45) }}</td>
          <td class="text-center">{{ ruta.longitud | humanDistance }}</td>
          <td class="text-center">{{ ruta.ascenso | humanDistance }}</td>
          <td class="text-center">{{ ruta.descenso | humanDistance }}</td>
          <td class="text-center border-right">{{ ruta.tiempo | humanTime }} h.</td>
          <td class="text-center ">{{ ruta.longitud | humanDistance }}</td>
          <td class="text-center">{{ ruta.descenso | humanDistance }}</td>
          <td class="text-center">{{ ruta.ascenso | humanDistance }}</td>
          <td class="text-center border-right">{{ ruta.vuelta | humanTime }} h.</td>
          <td class="text-center p-0 m-0 text-center">
            <a :href="`https://api.entrepyr.eu/geometries/route/${lang}/${ruta.id}.gpx`"
               class="btn btn-sm descargas rounded"><i class="fas fa-map-marked"></i></a>
          </td>
          <td class="text-center p-0 m-0 text-center">
            <a href="#" target="_blank"
               class="descargas btn btn-sm rounded disabled"><i class="fa fa-file-pdf"></i></a>
          </td>
          <td class="text-center p-0 m-0 text-center">
            <a :href="`/route/${ruta.id}.html`" target="_blank"
               class="rounded btn btn-sm descargas "><i class="fa fa-file"></i></a>
          </td>
          <td class="text-center p-0 m-0 text-center">
            <span class="btn btn-danger btn-sm rounded px-2" @click="borrarRuta(ruta)"><i
                class="fa fa-trash"></i></span>
          </td>
        </tr>
        </tbody>
      </table>

    </div>
    <div class="col-12 mt-4 d-flex flex-row justify-content-start align-items-center w-100">
      <button class="btn finalizarReserva mr-2" @click="comprobarCuaderno" href="/booking.html">
        {{
          texto.btnReservar
        }}
      </button>
      <button class="btn btn-danger" @click="borrarTodo">{{ texto.btnCancelar }}</button>
<!--      <button class="btn btn-info" @click="xsalto">TEST</button>-->
      <div class="estados flex-grow-1 d-flex flex-row justify-content-end align-items-center" v-if="!esMovil">
        <span class="flex-grow-0 rounded-circle estado disponible"></span>
        <span class="text-white ml-1 mr-2 texto">{{ texto.mdlEstados.abierto }}</span>
        <span class="flex-grow-0 rounded-circle estado online"></span>
        <span class="text-white ml-1 mr-2 texto">{{ texto.mdlEstados.online }}</span>
        <span class="flex-grow-0 rounded-circle estado guardado"></span>
        <span class="text-white ml-1 mr-2 texto">{{ texto.mdlEstados.guardado }}</span>
        <span class="flex-grow-0 rounded-circle estado cerrado"></span>
        <span class="text-white ml-1 mr-2 texto">{{ texto.mdlEstados.cerrado }}</span>
      </div>
    </div>
    <div class="mt-3 row d-flex flex-column justify-content-start align-items-center" v-if="mostrarXsalto">
     <div class="col-12 align-self-center">
        <div id="booking"></div>
      </div>
      <div class="col-4 align-self-center">
        <button class=" mb-1 btn btn-block btn-danger" @click="mostrarXsalto = false">
          {{ texto.btnCerrar }}
        </button>
      </div>
    </div>
    
  </div>
</template>

<script>

import {mapActions, mapState, mapGetters} from 'vuex';
import {EventBus} from "@/helpers/event-bus";
import cuaderno from "@/store/modules/cuaderno";
import {controlFechas} from "@/helpers/booking-helper";
import Refugio from "./Refugio";
import Ruta from "./Ruta";

export default {
  name: "CuadernoRuta",
  components: {Ruta, Refugio},
  props: {
    texto: Object,
    lang: String
  },
  data() {
    return {
      visibleCabecera: true,
      icono: false,
      showModal: false,
      showGuardado: false,
      mostrarMensaje: false,
      mostrarEncuesta: false,
      mostrarRuta: false,
      mostrarXsalto: false,
      offset: 0,
      errorNoches: 'Este refugio no permite tantas pernoctas consecutivas',
      esMovil: false
    }
  },
  created() {

    switch (this.lang) {
      case 'fr':
        this.errorNoches = 'Ce refuge ne permet pas autant de nuits consécutives';
        break;
      case 'cat':
        this.errorNoches = 'Aquest refugi no permet tantes pernoctes consecutives';
        break;
      case 'en':
        this.errorNoches = 'This refuge does not allow so many consecutive nights';
        break;
    }
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.esMovil = true
    }
  },
  computed: {
    ...mapState({
      diasDisponibles: state => state.cuaderno.diasPosibles
    }),
    ...mapGetters('cuaderno', {
      cuaderno: 'refugiosCuaderno',
      rutas: 'rutasCuaderno'
    }),

  },
  methods: {
    ...mapActions('cuaderno', ['addRefugio']),
    anteriores() {
      const desplaza = this.offset + 90
      if (desplaza <= 600) {
        document.getElementsByClassName('cuaderno-datos-dias').forEach((item) => {
          item.scrollLeft = desplaza
        })
        this.offset = desplaza
      } else this.offset = 600
    },
    posteriores() {
      const desplaza = this.offset - 90
      if (desplaza >= 0) {
        document.getElementsByClassName('cuaderno-datos-dias').forEach((item) => {
          item.scrollLeft = desplaza
        })
        this.offset = desplaza
      } else this.offset = 0
    },
    dropRefugio(ev) {
      ev.preventDefault()
      const origen = ev.dataTransfer.getData('id');
      this.$store.dispatch('cuaderno/reordenar', {origen, destino: ev.target.dataset.id})

    },
    dragRefugio(ev) {
      ev.dataTransfer.setData('id', ev.target.dataset.id);
    },
    estadoDia(dia, refugio) {
      const ref = this.$store.state.refugios.all.find(r => r.id == refugio.id);
      // Si el grupo > plazas permitidas devolver cerrado
      if(parseInt(this.$store.state.cuaderno.personas) > parseInt(ref.personas))
        return 'bg-danger disabled';
      
      // Si no tiene id de xsalto que llamen
      if(ref.xsalto === "0") return 'bg-warning disabled no-disponible';

      // Si grupo > plazas libres en la fecha devolver cerrado
      if (parseInt(this.$store.state.cuaderno.personas) > parseInt(ref.fechas[dia].plazas))
        return 'bg-danger disabled';

      let estado = 'bg-success ';
      let disabled = '';


      if (!ref.fechas[dia].guardado) estado = 'bg-info ';
      if (ref.fechas[dia].cerrado) estado = 'bg-danger disabled';
      if (ref.fechas[dia].online) estado = 'bg-warning disabled no-disponible';

      if (this.$store.state.cuaderno.diasEscogidos.includes(dia) && !refugio.fechas.includes(dia)) disabled = 'disabled';

      return estado + disabled;
    },
    diaPulsado(refugio, fecha) {
      const ref = this.$store.state.refugios.all.find(ref => ref.id === refugio.id);

      if (!ref.fechas[fecha].guardado && !this.$store.state.cuaderno.diasEscogidos.includes(fecha))
        this.showGuardado = true;

      const bloqueadas = controlFechas.bloquearFechas(refugio.fechas, parseInt(ref.limiteDias));
      // Si esta la fecha se va a quitar
      if (refugio.fechas.includes(fecha)) {
        this.$store.dispatch('cuaderno/agregarDia', {refugioId: refugio.id, fecha});
      } else {
        if (!bloqueadas.includes(fecha))
          this.$store.dispatch('cuaderno/agregarDia', {refugioId: refugio.id, fecha});
        else alert(this.errorNoches)
      }
    },

    removerRefugio(refugioId) {

      EventBus.$emit('accion', {borrar_refugio: refugioId})
      this.$store.dispatch('cuaderno/removeRefugio', refugioId);
      if (this.cuaderno.length === 0) {
        EventBus.$emit('limpiarMapa');
        EventBus.$emit('limpiarFiltros');
        EventBus.$emit('accion', {limpiar_cuaderno: 'cuaderno borrado por completo'})
      } else {
        EventBus.$emit('borrarUltimo', this.cuaderno[this.cuaderno.length - 1].id);
      }
    },
    borrarTodo() {
      this.$store.dispatch('cuaderno/limpiarCuaderno');
      EventBus.$emit('limpiarMapa');
      EventBus.$emit('limpiarFiltros');
      EventBus.$emit('accion', {limpiar_cuaderno: 'cuaderno borrado por completo'})
    },
    borrarRuta(ruta) {
      this.$store.dispatch('cuaderno/addRuta', ruta);
      EventBus.$emit('quitarRutaCuaderno', ruta.id);
      EventBus.$emit('accion', {quitar_ruta_cuaderno: ruta})
    },
    comprobarCuaderno() {
      let vacio = false;
      cuaderno.state.items.forEach(refugio => {
        if (refugio.fechas.length === 0)
          vacio = true
      });
      if (vacio) {
        this.mostrarMensaje = true
      } else if (cuaderno.state.rutas.length == 0) {
        this.mostrarRuta = true
      } else {
        //this.mostrarEncuesta = true
        this.xsalto();
        //window.location.replace("/booking.html");
      }
    },
    xsalto() {
      this.mostrarRuta = false
      this.mostrarXsalto = true
      setTimeout(() => {

        let contador = 0;
        let result = '';
        let structures = [];
        this.cuaderno.forEach( ref => {
          structures.push(ref.xsalto);
          ref.fechas.forEach(fecha => {
            result += contador+"[bookDays][]=";
            result += fecha.toString()+"&";
            result += contador+"[structure]=BK_STRUCTURE:"+ref.xsalto+"&";
            contador++;
          })
        });
        const xsaltoLangs = {
          'es': 'SP',
          'fr': 'FR',
          'en': 'GB',
          'cat': 'SP'
        };
        result += "length="+contador;

        let BK_opts = {
          target: 'booking',
          structure:`${structures[0]}`,
          action: '',
          lang: xsaltoLangs[this.lang],
          //apporigin:'FAM',
          apporigin:'ENTREPYRPYRENEES',
          structures: structures,
          css: 'https://refugit.entrepyr.eu/css/widget-resa/entrepyrpyrenees/widget-resa.css',
          data: {
            source_user_data: {
              email: "",
              firstName: "",
              name: "",
              address: "",
              postalCode: "",
              city: "",
              country: "",
              phone: ""
            }
          }
        };


        BK_opts.data['action']='book';
        BK_opts.data['pax']=`${this.$store.state.cuaderno.personas}`;
        BK_opts.data['bookStack'] = result;

        // eslint-disable-next-line no-undef
        BK_widget.init(BK_opts);
        window.enlarge_reservation_iframe;
        // eslint-disable-next-line no-undef
        $(document.head).prepend('<meta http-equiv="refresh" content="3600">');
      }, 250);
    }
  }
}
</script>

<style scoped>
/*.col-9.text-white.d-flex.p-0:hover {
  cursor: pointer;
}*/
.ripple-surface {
  overflow: initial !important;
}

.cuaderno-datos-dias {
  overflow-x: scroll;
  scroll-behavior: smooth;
}

.cuaderno-datos-dias::-webkit-scrollbar {
  height: 0px;
}

.cuaderno-control-fechas button {
  background-color: #4d567c;
  width: 90px;
  height: 30px;
  border: 1px solid #42b983;
  color: white;
}

.cuaderno-control-fechas button:hover {
  background-color: #42b983;
}

.cuaderno-control-fechas button:first-child {
  margin: 0 0.5rem;
}

.cuaderno-nombre-refugio {
  width: 275px;
}

.cuaderno-borrar-refufio {
  max-width: 45px;
}

.boton-papelera {
  height: 50px;
  padding: 0;
  background-color: rgba(249, 49, 84, 1);
  color: white;
  width: 30px;
  border: none;
  border-radius: 5px;
  margin-left: 7.5px;
}

.finalizarReserva, .descargas {
  background-color: #42b983;
  color: white;
}

.estados {
  height: 40px;
  padding: 5px;
}

.estados span.estado {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: white;
}

.estados span.texto {
  font-size: 14px;
  font-weight: 700;
}

span.estado.disponible {
  background-color: rgba(0, 183, 74, 1);
}

span.estado.online {
  background-color: rgba(255, 169, 0, 1);
}

span.estado.guardado {
  background-color: rgba(0, 212, 255, 1);
}

span.estado.cerrado {
  background-color: rgba(249, 49, 84, 1);
}

.bg-secondary {
  background-color: #6c757d !important;
}

.fecha {
  font-size: 0.8rem;
}

.disponible {
  filter: brightness(100%);
}

.seleccionado {
  box-shadow: 0px 0px 5px 5px rgba(0, 103, 255, 0.75);
}

.datos-ruta td {
  padding: 0.4rem 0;
}

.table {
  margin-bottom: 0;

}

.table > :not(caption) > * > * {
  padding: 0;
}

.ascenso {
  transform: rotate(-45deg);
}

.descenso {
  transform: rotate(45deg);
}

/*

td.borrar-ruta:hover,
.enlace:hover {
  cursor: pointer;
}*/

button.info {
  width: 1.2rem;
  height: 1.2rem;
  background: linear-gradient(0deg, rgba(0, 183, 74, 1) 0%, rgba(255, 169, 0, 1) 25%, rgba(0, 212, 255, 1) 50%, rgba(249, 49, 84, 1) 75%);
  margin: 0 0.2rem;
}

.leyenda-texto {
  font-size: 0.8rem;
  padding-left: 1rem;
  padding-right: 1rem;
  vertical-align: baseline;
}

.abrir-modal {
  font-size: 18px;
  min-height: 10px;
  vertical-align: middle;
}

.abrir-modal:hover {
  cursor: pointer;
}

.abrir-modal .leyenda {
  width: 10px;
  height: 10px;
  display: inline-block;
}


.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.card-body.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-container.encuesta,
.modal-container.xsalto {
  width: 65%;
  text-align: center;
  background-color: #4d567c;
  color: white;
  padding: 0;
}
.modal-container.xsalto > #if_booking {
  max-height: 90vh!important;
}

.modal-container.encuesta img {
  width: 92px;
  margin: 0 0.5rem;
}

.modal-container.xsalto img {
  width: 250px;
}


.modal-container.encuesta img.ok {
  width: 256px;
  margin: 0.5rem 0;
  text-align: center;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

@media screen and (max-width: 768px) {
  .modal-container.xsalto img {
    width: 250px;
  }

  .modal-container.xsalto {
    width: 95%;
  }
}
</style>